export default __webpack_public_path__ + "static/media/celular-contacto.eeb7d584.png";